/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ComplaintSummaryResponse,
    ComplaintSummaryResponseFromJSON,
    ComplaintSummaryResponseFromJSONTyped,
    ComplaintSummaryResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface BatchProcessingData
 */
export interface BatchProcessingData {
    /**
     * 
     * @type {number}
     * @memberof BatchProcessingData
     */
    inputTokenCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BatchProcessingData
     */
    outputTokenCount?: number;
    /**
     * 
     * @type {ComplaintSummaryResponse}
     * @memberof BatchProcessingData
     */
    complaintInfo?: ComplaintSummaryResponse;
}

export function BatchProcessingDataFromJSON(json: any): BatchProcessingData {
    return BatchProcessingDataFromJSONTyped(json, false);
}

export function BatchProcessingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchProcessingData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inputTokenCount': !exists(json, 'inputTokenCount') ? undefined : json['inputTokenCount'],
        'outputTokenCount': !exists(json, 'outputTokenCount') ? undefined : json['outputTokenCount'],
        'complaintInfo': !exists(json, 'complaintInfo') ? undefined : ComplaintSummaryResponseFromJSON(json['complaintInfo']),
    };
}

export function BatchProcessingDataToJSON(value?: BatchProcessingData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inputTokenCount': value.inputTokenCount,
        'outputTokenCount': value.outputTokenCount,
        'complaintInfo': ComplaintSummaryResponseToJSON(value.complaintInfo),
    };
}


